<template>
	<div class="org_school">

		<el-card shadow="hover">
			<el-row>
				<el-col :span="12">
					<div class="grid-content bg-purple">
						<el-input placeholder="请输入内容" v-model="search_name">
							<template slot="prepend">学校名称</template>
						</el-input>
					</div>
				</el-col>
			</el-row>
		</el-card>

		<el-card shadow="hover" style="margin-top: 10px;">
			<div slot="header" class="clearfix">
				<span>学校列表({{tableDataCount}})</span>
				<el-button style="float: right; padding: 3px 0" type="text" @click="dialogEdit = true">添加学校
				</el-button>
			</div>
			<el-table :data="showDate()">
				<el-table-column fixed type="index" width="50" align="center">
					<template slot-scope="scope">
						{{(page_current-1)*page_size+scope.$index+1}}
					</template>
				</el-table-column>
				<el-table-column prop="name" label="学校名称" align="left">
				</el-table-column>
				<el-table-column prop="logo" label="logo" align="left">
					<template slot-scope="scope">
						<!-- <img :src="$http.fileUrl+scope.row.logo" style="height: 50px;" /> -->
						<el-image :src="$http.fileUrl+scope.row.logo" style="height: 50px;"></el-image>
					</template>
				</el-table-column>
				<el-table-column prop="firstLetter" label="首字母" align="left">
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" align="center" width='160'></el-table-column>
				<el-table-column fixed="right" label="操作" align="center" width="200">
					<template slot-scope="scope">
						<el-button type="primary" icon="el-icon-edit" style="margin-right: 10px;" size="mini"
							@click="dialogEdit2_data= scope.row; dialogEdit2 = true">编辑</el-button>
						<el-popconfirm confirm-button-text='确认' cancel-button-text='取消' icon="el-icon-info"
							icon-color="red" title="确定删除吗？" @confirm="del(scope.row.id)">
							<el-button slot="reference" type="danger" icon="el-icon-delete" size="mini">
								删除</el-button>
						</el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background layout="total, sizes, prev, pager, next, jumper" :total="tableDataCount"
				class="pagination" @size-change="sizeChange" @current-change="currentChange">
			</el-pagination>

		</el-card>
		<school-edit type="add" title="添加学校" :dialogVisible="dialogEdit"
			@before-close="dialogEdit=false;loadSchoolArray()" :SchoolArray="getSchoolArray"></school-edit>
		<school-edit type="update" title="编辑学校" :dialogVisible="dialogEdit2"
			@before-close="dialogEdit2=false;loadSchoolArray()" :obj="dialogEdit2_data" :SchoolArray="getSchoolArray">
		</school-edit>
	</div>
</template>

<script>
	import schoolEdit from './school/edit'

	export default {
		data() {
			return {
				page_size: 10,
				page_current: 1,
				search_name: '',
				tableDataCount: 0,
				dialogEdit: false,
				dialogEdit2: false,
				dialogEdit2_data: null,
				getSchoolArray: []
			}
		},
		methods: {
			loadSchoolArray() {
				this.$http.get('api/Org/GetSchools').then(res => {
					this.getSchoolArray = res.data.data
				})
			},
			sizeChange(e) {
				this.page_size = e
			},
			currentChange(e) {
				this.page_current = e
			},
			showDate() {
				if (this.getSchoolArray) {
					let _data = this.getSchoolArray.filter(item => item.name && item.name
						.search(
							this.search_name) > -1)
					this.tableDataCount = _data.length
					return _data.slice((this.page_current - 1) * this.page_size, this.page_current *
						this.page_size)
				}
			},
			del(id) {
				this.$http.get('api/Org/DelSchools/' + id).then(res => {
					if (res.data.code == "1") {
						this.loadSchoolArray()
					} else {
						this.$message({
							message: "删除失败：" + res.data.data,
							type: 'error'
						})
					}
				})
			}
		},
		mounted() {
			this.loadSchoolArray()
		},
		components: {
			schoolEdit
		}
	}
</script>

<style lang="scss">
	.org_school {
		.pagination {
			margin: 10px 0;
			text-align: center;
		}
	}
</style>
